import styles from "./PayslipStyle";
import { extractSalary } from "../../../../components/common/Converter";
import {
  _sumDeductions,
  _formatPayrollPeriod,
  _withItem,
  _getFullName,
} from "./PayslipHelper";
import HeaderContent from "./payslip-content/HeaderContent";
import NameAndTitleContent from "./payslip-content/NameAndTitleContent";
import BodyContent from "./payslip-content/BodyContent";
import { _payslipCalculations } from "./payslip-calculations/PayslipCalculations";

export default function PrintPayslip({
  object,
  accountsTitle,
  monthlyRate,
  showWatermark = true,
}) {
  const item = object[0];

  const fullName = _getFullName(item?.employee);
  const basicRate = extractSalary(monthlyRate);
  const sumOfDeductions = _sumDeductions(item?.deductions);
  const sumOfContributions = _sumDeductions(item?.contributions);
  const date = _formatPayrollPeriod(item?.startDate, item?.endDate);
  const apRate = item?.payCode;

  const checkCase = _withItem(item);

  const params = {
    item,
    basicRate,
    checkCase,
    sumOfDeductions,
    sumOfContributions,
  };

  console.log("item", item);

  const { computedValues, displayValues } = _payslipCalculations(params);

  console.log("displayValues", displayValues);

  return (
    <>
      {showWatermark && (
        <style>
          {`
            @media print {
              .payslip-print-root {
                min-height: 100vh;
              }
            }
          `}
        </style>
      )}
      <div
        className={showWatermark ? "payslip-print-root" : undefined}
        style={{
          position: "relative",
          ...(showWatermark && { minHeight: "100vh" }),
          width: "100%",
          boxSizing: "border-box",
          ...(showWatermark && {
            WebkitPrintColorAdjust: "exact",
            printColorAdjust: "exact",
          }),
        }}
      >
        {showWatermark && (
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url(/dtrwatermark.png)",
              backgroundRepeat: "repeat",
              backgroundPosition: "center",
              backgroundSize: "auto",
              pointerEvents: "none",
              zIndex: 0,
            }}
          />
        )}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            padding: "5px",
            fontFamily: "sans-serif",
          }}
        >
          <HeaderContent styles={styles} />
          <NameAndTitleContent
            styles={styles}
            fullName={fullName}
            date={date}
            checkCase={checkCase}
          />
          <BodyContent
            styles={styles}
            item={item}
            accountsTitle={accountsTitle}
            displayValues={displayValues}
            computedValues={computedValues}
            apRate={apRate}
            checkCase={checkCase}
          />
        </div>
      </div>
    </>
  );
}
